import ReactDOM from 'react-dom/client';
import { TenantContext } from '../../../context/tenant-context';
import { v2Component } from '../../../index';
import { ToastContainer } from 'react-toastify';
import { AssignInspectionWorkflow } from './assign-inspection-workflow';

export function initAssignInspectionWorkflow() {
  document.getElementsByName('assign-inspection-workflow').forEach((element) => {
    if (element.getAttribute('initialized') !== 'true') {
      element.setAttribute('initialized', 'true');
      const root = ReactDOM.createRoot(element);

      const bootstrap = () => {
        const { tenant, contextPath, ...dataset } = Object.assign({}, element.dataset) as any;
        root.render(
          v2Component(
            <TenantContext.Provider value={{ tenant, contextPath, spaMode: false }}>
              <ToastContainer />
              <AssignInspectionWorkflow {...dataset} />
            </TenantContext.Provider>,
          ),
        );
      };

      bootstrap();
    }
  });
}
